import axios from "axios";

export const isolatedAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true
});

const _axios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true
});
export default _axios;

export const fileAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  withCredentials: true
});
